var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.995,19.28l7.712-7.712H19.923V3.856H16.067v7.712H10.283Zm7.011-3.155-2.161,2.161,7.835,2.922-12.685,4.73L5.31,21.208l7.835-2.922-2.161-2.161L2.571,19.28v7.712l15.424,5.784,15.424-5.784V19.28Z","transform":"translate(-2.571 -3.856)"}));
}

Download.defaultProps = {"width":"30.849","height":"28.921","viewBox":"0 0 30.849 28.921"};

module.exports = Download;

Download.default = Download;
